(function () {
  console.log("[Attribution] Script initialized");

  const storageKey = "jbg_attribution";
  const trackedParams = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "view"
];

  const url = new URL(window.location.href);
  const params = url.searchParams;

  let data = JSON.parse(localStorage.getItem(storageKey) || "{}");

  if (!data.landing_page_path) {
    data.landing_page_path = window.location.pathname;
  }

  data.last_page_path = window.location.pathname;

  trackedParams.forEach(function (key) {
  const value = params.get(key);

  if (value) {
    if (key === "view") {
      // Map any Replo variant to a clean label
      data.ab_variant = "test_variant";
      console.log("[Attribution] Mapped view → ab_variant:test_variant");
    } else {
      data[key] = value.toLowerCase().trim();
      console.log(`[Attribution] Captured ${key}:`, data[key]);
    }
  }
  });

  localStorage.setItem(storageKey, JSON.stringify(data));

  function updateCartAttributes(extraAttributes) {
    const attributes = {
      landing_page_path: data.landing_page_path || "",
      last_page_path: data.last_page_path || "",
      checkout_referrer_path: data.checkout_referrer_path || "",
      utm_source: data.utm_source || "",
      utm_medium: data.utm_medium || "",
      utm_campaign: data.utm_campaign || "",
      utm_content: data.utm_content || "",
      utm_term: data.utm_term || "",
      ab_variant: data.ab_variant || "",
      ...extraAttributes
    };

    console.log("[Attribution] Updating cart attributes:", attributes);

    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ attributes })
    });
  }

  updateCartAttributes();

  document.addEventListener("click", function (event) {
    const checkoutLink = event.target.closest(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"]'
    );

    if (!checkoutLink) return;

    data.checkout_referrer_path = window.location.pathname;
    localStorage.setItem(storageKey, JSON.stringify(data));

    console.log("[Attribution] Checkout click detected");
    console.log("[Attribution] checkout_referrer_path:", data.checkout_referrer_path);

    updateCartAttributes({
      checkout_referrer_path: data.checkout_referrer_path
    });
  });
})();
